export default __webpack_public_path__ + "static/media/_Y.43a5d6f0.png";